/* Shared media layers: video > image > stars. No network requests or tracking. */
(()=>{
 function init(root=document){
  if(!document.getElementById('spirit-cabinet'))return;
  root.querySelectorAll('#main .hero,#trade .door,#savor-agave .sav-photo,#recipes .shr-feature').forEach(box=>{
   box.classList.add('stellar-media-box');
   if(!box.querySelector(':scope > .stellar-media-fade')){const fade=document.createElement('span');fade.className='stellar-media-fade';fade.setAttribute('aria-hidden','true');box.append(fade);}
   let node=box.closest('section')||box.parentElement,color='';
   while(node){const c=getComputedStyle(node).backgroundColor;if(c!=='transparent'&&c!=='rgba(0, 0, 0, 0)'){color=c;break;}node=node.parentElement;}
   color=color||'#0b0b0c';box.style.setProperty('--media-surface',color);
   const c=color.match(/[0-9.]+/g),light=c&&(.2126*+c[0]+.7152*+c[1]+.0722*+c[2])>155;box.style.setProperty('--media-title',light?'#252722':'#f1ede6');
  });
  root.querySelectorAll('#main .slot,#savor-agave .sav-photo,#recipes .shr-feature,#recipes .shr-card-image').forEach(slot=>{
   if(slot.dataset.stellarFallback)return;slot.dataset.stellarFallback='true';
   const stars=document.createElement('span');stars.className='stellar-media-stars';stars.setAttribute('aria-hidden','true');slot.prepend(stars);
   const realImage=[...slot.querySelectorAll('img')].find(img=>!img.closest('video'));
   const video=slot.querySelector('video');if(video&&!realImage&&video.poster){const img=document.createElement('img');img.className='stellar-media-poster';img.alt='';img.src=video.poster;slot.insertBefore(img,video);}
   const media=[...slot.querySelectorAll('img,video')].filter(m=>m.tagName==='VIDEO'||!m.closest('video'));
   const failed=new WeakSet();
   function update(){
    const waitsForPlayback=!!slot.querySelector(':scope > .sx-poster');
    slot.dataset.stellarMediaReady=String(media.some(m=>!failed.has(m)&&(m.tagName==='IMG'?m.complete&&m.naturalWidth>0:m.readyState>=2&&!m.error&&getComputedStyle(m).display!=='none'&&(!waitsForPlayback||!m.classList.contains('sx-vid')||m.classList.contains('is-ready')))));
   }
   media.forEach(m=>{
    function restore(){failed.delete(m);m.style.visibility='';update();}
    function fail(){failed.add(m);m.style.visibility='hidden';if(m.tagName==='VIDEO')m.classList.remove('is-ready');update();}
    m.addEventListener('load',restore);m.addEventListener('loadeddata',restore);m.addEventListener('playing',restore);m.addEventListener('error',fail);
    if(m.tagName==='IMG'?m.complete&&!m.naturalWidth:!!m.error)fail();
   });
   if(slot.querySelector('.sx-vid--mobile,.sx-vid--desktop')){
    const viewport=window.matchMedia('(min-width:700px)');
    if(viewport.addEventListener)viewport.addEventListener('change',update);else viewport.addListener(update);
   }
   update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',()=>init());
})();
